// @flow
import produce from 'immer';
import _ from 'lodash';

import * as actions from 'client/constants/actions';

export type ChoiceType = {
	lastVotedTotalRate: number,
	list: {
		[key: string]: number,
	},
};

export type Action = {
	type: string,
	payload: ChoiceType,
};

const initialState: ChoiceType = {};

export default function choiceReducer(state: ChoiceType = initialState, { type, payload }: Action) {
	return produce(state, draft => {
		switch (type) {
			case actions.SAVE_USER_CHOICE.SUCCESS:
				_.set(draft, `list.${payload.list.id}`, payload.list.rate);
				_.set(draft, `lastVotedTotalRate`, payload.lastVotedTotalRate);
				break;

			default:
				break;
		}
	});
}
